module.exports = __webpack_public_path__ + "static/media/liaoyang-2@2x.dc9d6cdb.png";